const Content = {
  'expertise': {
    'content': {
      'icons': [
        { 'iconName': 'strategy', 'iconType': 'IconImage', 'description': 'Strategy' },
        { 'iconName': 'franchise-management', 'iconType': 'IconImage', 'description': 'Franchise Management'},
        { 'iconName': 'positioning', 'iconType': 'IconImage', 'description': 'Positioning' },
        { 'iconName': 'creative-materials-testing', 'iconType': 'IconImage', 'description': 'Creative Materials Testing' },
        { 'iconName': 'content-testing', 'iconType': 'IconImage', 'description': 'Content Testing' },
        { 'iconName': 'campaign-tracking', 'iconType': 'IconImage', 'description': 'Campaign Tracking' }
      ]
    },
    'interactive': {
      'icons': [
        { 'iconName': 'franchise-management', 'iconType': 'IconImage', 'description': 'Franchise Management' },
        { 'iconName': 'light-bulb', 'description': 'Concept Development' },
        { 'iconName': 'creative-materials-testing', 'iconType': 'IconImage', 'description': 'Creative Materials Testing' },
        { 'iconName': 'ux-testing', 'iconType': 'IconImage', 'description': 'UX Testing' },
        { 'iconName': 'campaign-tracking', 'iconType': 'IconImage', 'description': 'Campaign Tracking' }
      ]
    },
    'platform': {
      'icons': [
        { 'iconName': 'marketing-and-audience-landscaping', 'iconType': 'IconImage', 'description': 'Market & Audience Landscaping' },
        { 'iconName': 'positioning-platforms-optimization', 'iconType': 'IconImage', 'description': 'Positioning & Platform Optimization' },
        { 'iconName': 'creative-materials-testing', 'iconType': 'IconImage', 'description': 'Creative Materials Testing' },
        { 'iconName': 'brand-strategy-tracking', 'iconType': 'IconImage', 'description': 'Brand Strategy & Tracking' },
        { 'iconName': 'next-gen', 'iconType': 'IconImage', 'description': 'Next Gen Strategy Development' }
      ]
    },
    'brand': {
      'icons': [
        { 'iconName': 'heart-plus', 'description': 'Brand Management' },
        { 'iconName': 'segmentation-targeting', 'iconType': 'IconImage', 'description': 'Segmentation & Targeting' },
        { 'iconName': 'positioning-two', 'description': 'Positioning Strategy' },
        { 'iconName': 'creative-materials-testing', 'iconType': 'IconImage', 'description': 'Creative Materials Testing' },
        { 'iconName': 'campaign-effectiveness', 'iconType': 'IconImage', 'description': 'Campaign Effectiveness' }
      ]
    }
  }
};

export { Content };
